import { Injectable } from '@angular/core';
import { APP_CONST } from '../../app.const';
import { RequestService } from '../../libraries/http/request.service';

@Injectable()
export class SuratJalanBateraiRestService {
  baseURL = `${APP_CONST.API_MASTER}/admin/surat-jalan-baterai`;
  request = this._request.new(this.baseURL);

  constructor(private _request: RequestService) {}

  findAll(queryParams: any = {}) {
    return this.request.get<any>(`/`, { params: queryParams });
  }

  getDetail(id) {
    return this.request.get(`/${id}`);
  }

  close(id) {
    return this.request.patch(`/close/${id}`);
  }

  create(payload) {
    return this.request.post('/', payload);
  }

  saveDraft(payload) {
    return this.request.post('/save-draft', payload);
  }

  submitDraft(id, payload) {
    return this.request.patch(`/submit-draft/${id}`, payload);
  }

  approve(id) {
    return this.request.patch(`/approve/${id}`);
  }

  reject(id, reason) {
    return this.request.patch(`/reject/${id}`, { reason });
  }

  deliver(id) {
    return this.request.patch(`/deliver/${id}`);
  }

  getSjbType() {
    return this.request.get(`/type`);
  }

  getDealerAddress() {
    return this.request.get(`/dealer-address`);
  }

  getDealerUser() {
    return this.request.get(`/dealer-by-user`);
  }

  getPresignedUrl(payload) {
    const req = this._request.new(`${APP_CONST.API_MASTER}`);
    return req.post<any>('/admin/spk/pre-signed-url', payload)
  }

  getDealers() {
    const req = this._request.new(`${APP_CONST.API_MASTER}`);
    return req.get('/admin/spk/get-dealers');
  }

  getCustomerData(ktp: string) {
    return this.request.get(`/customer/${ktp}`);
  }

  isDealerWhitelist() {
    return this.request.get(`/is-dealer-whitelist`);
  }

  getStbList(name?: string) {
    return this.request.get(`/stb-list?name=${name}`);
  }
}
